import { BaseService } from '@colescba/services'

const createInput = (name, value) => {
  let element = document.createElement('input')
  element.name = name
  element.value = value
  return element
}

export class ReportesService extends BaseService {
  /**
   * Genera un reporte en PDF a partir de un HTML.
   *
   * @param {Object} args
   * @param {String} args.html
   * @param {String} args.format
   * @param {Boolean} args.displayHeaderFooter
   * @param {String} args.header
   * @param {String} args.footer
   * @param {Object} args.margin
   * @param {Boolean} args.sign
   * @param {String} args.codigoServicioOrigen requerido si sign=true
   * @param {String} args.codigoServicioDestino requerido si sign=true
   * @param {Number} args.usuarioCargaId requerido si sign=true
   */
  async generarReportePDF(args) {
    // Fuerzo sin firma
    args.sign = false
    const response = await this.http.post('/report/', args)
    return response.data
  }

  /**
   * Genera un reporte en PDF raw a partir de un HTML.
   *
   * @param {Object} args
   * @param {String} args.html
   * @param {String} args.format
   * @param {Boolean} args.displayHeaderFooter
   * @param {String} args.header
   * @param {String} args.footer
   * @param {Object} args.margin
   * @param {Boolean} args.sign
   * @param {String} args.title opcional para agregar al pdf un título como metadata
   * @param {String} args.codigoServicioOrigen requerido si sign=true
   * @param {String} args.codigoServicioDestino requerido si sign=true
   * @param {Number} args.usuarioCargaId requerido si sign=true
   */
  async generarReportePDFRaw(args) {
    // Fuerzo sin firma
    args.sign = false

    var form = document.createElement('form')

    form.setAttribute('method', 'post')
    form.setAttribute('action', `${this.baseURL}/report/raw`)
    form.setAttribute('target', '_blank')
    form.setAttribute('hidden', true)

    args.html = Array.isArray(args.html) ? args.html : [args.html]
    for (let i = 0; i < args.html.length; i++) {
      form.appendChild(createInput(`html[${i}]`, args.html[i]))
    }
    form.appendChild(createInput('format', args.format))
    form.appendChild(createInput('displayHeaderFooter', args.displayHeaderFooter))
    form.appendChild(createInput('title', args.title))
    if (args.displayHeaderFooter) {
      form.appendChild(createInput('header', args.header))
      form.appendChild(createInput('footer', args.footer))
    }
    for (let marginKey in args.margin) {
      form.appendChild(createInput(`margin[${marginKey}]`, args.margin[marginKey]))
    }
    form.appendChild(createInput('sign', args.sign))
    document.body.appendChild(form)
    form.submit()
  }
}
